export default "__VITE_ASSET__42e8Qkc9__"